import { Field } from 'devextreme/ui/pivot_grid/data_source';

export const value_3: Field = {
  dataField: 'value_3',
  dataType: 'number',
  summaryType: 'sum',
  isMeasure: true,
  format: {
    type: 'fixedPoint',
  },
};

export const value_3_precision: Field = {
  ...value_3,
  format: {
    type: 'fixedPoint',
    precision: 3,
  },
};

export const value_3_data: Field = {
  ...value_3,
  area: 'data',
};

export const value_3_data_precision: Field = {
  ...value_3_data,
  format: {
    type: 'fixedPoint',
    precision: 3,
  },
};

export const value_3_no_year_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return e.field('row') && e.field('row').name === 'year' ? undefined : e.value(false);
  },
};

export const value_3_no_year_half_year_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return (e.field('row') && e.field('row').name === 'year') || (e.field('row') && e.field('row').name === 'halfYear')
      ? undefined
      : e.value(false);
  },
};

export const value_3_no_year_month_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return (e.field('row') && e.field('row').name === 'year') || (e.field('row') && e.field('row').name === 'month') ? undefined : e.value(false);
  },
};

export const huf_kilowatt_ora_value_3: Field = {
  ...value_3,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_3_data: Field = {
  ...value_3_data,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_3_data_precision: Field = {
  ...value_3_data_precision,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_3_no_year_summary: Field = {
  ...huf_kilowatt_ora_value_3,
  ...value_3_no_year_summary,
};

export const huf_kilowatt_ora_value_3_no_year_month_summary: Field = {
  ...huf_kilowatt_ora_value_3,
  ...value_3_no_year_month_summary,
};

export const huf_kilowatt_ora_value_3_data_no_year_summary: Field = {
  ...huf_kilowatt_ora_value_3_data,
  ...value_3_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_kilowatt_ora_value_3_data_no_year_half_year_summary: Field = {
  ...huf_kilowatt_ora_value_3_data_precision,
  ...value_3_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_kilowatt_ora_value_3_data_precision_no_year_half_year_summary: Field = {
  ...huf_kilowatt_ora_value_3_data_precision,
  ...value_3_no_year_half_year_summary,
};

export const huf_kilowatt_ora_value_3_data_no_year_month_summary: Field = {
  ...huf_kilowatt_ora_value_3_data,
  ...value_3_no_year_month_summary,
};

export const terajoule_brutto_value_3: Field = {
  ...value_3,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_3_precision: Field = {
  ...value_3_precision,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_3_data: Field = {
  ...value_3_data,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_3_data_precision: Field = {
  ...value_3_data_precision,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_3_no_year_summary: Field = {
  ...terajoule_brutto_value_3,
  ...value_3_no_year_summary,
};

export const terajoule_brutto_value_3_no_year_month_summary: Field = {
  ...terajoule_brutto_value_3,
  ...value_3_no_year_month_summary,
};

export const terajoule_brutto_value_3_data_no_year_summary: Field = {
  ...terajoule_brutto_value_3_data,
  ...value_3_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_3_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_3,
  ...value_3_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_3_precision_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_3_precision,
  ...value_3_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_3_data_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_3_data,
  ...value_3_no_year_half_year_summary,
};

export const terajoule_brutto_value_3_data_no_year_month_summary: Field = {
  ...terajoule_brutto_value_3_data,
  ...value_3_no_year_month_summary,
};

export const terajoule_netto_value_3: Field = {
  ...value_3,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_3_precision: Field = {
  ...value_3_precision,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_3_data: Field = {
  ...value_3_data,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_3_no_year_summary: Field = {
  ...terajoule_netto_value_3,
  ...value_3_no_year_summary,
};

export const terajoule_netto_value_3_no_year_month_summary: Field = {
  ...terajoule_netto_value_3,
  ...value_3_no_year_month_summary,
};

export const terajoule_netto_value_3_data_no_year_summary: Field = {
  ...terajoule_netto_value_3_data,
  ...value_3_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_3_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_3,
  ...value_3_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_3_precision_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_3_precision,
  ...value_3_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_3_data_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_3_data,
  ...value_3_no_year_half_year_summary,
};

export const terajoule_netto_value_3_data_no_year_month_summary: Field = {
  ...terajoule_netto_value_3_data,
  ...value_3_no_year_month_summary,
};

export const huf_gigajoule_brutto_value_3_data: Field = {
  ...value_3_data,
  caption: 'huf_gigajoule_brutto',
};

export const gigawatt_ora_value_3_data: Field = {
  ...value_3_data,
  caption: 'gigawatt_ora',
};
